module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-dark box vacations-days__wrapper"
  }, [(_vm.isKindergarten) ? _c('h1', [_vm._v("Lukkedage")]) : _c('h1', [_vm._v(_vm._s(_vm.$t('vue.vacations_days_selector.vacation_for_pupils')))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "marg-20-right flex align-center"
  }, [(_vm.isKindergarten) ? _c('span', {
    staticClass: "font-large"
  }, [_vm._v("Periode")]) : _c('span', {
    staticClass: "font-large"
  }, [_vm._v(_vm._s(_vm.$t('vue.vacations_days_selector.school_year')) + " ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSchoolYearIndex),
      expression: "selectedSchoolYearIndex"
    }],
    staticClass: "marg-1-left like-date-picker",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSchoolYearIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onSchoolYearChanged]
    }
  }, _vm._l((_vm.activeSchoolYears), function(schoolYear, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v("\n          " + _vm._s(schoolYear.name) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "marg-1-left marg-1-right"
  }, [_c('date-picker-range', {
    staticClass: "inline-block",
    attrs: {
      "startdate": _vm.currFromDate,
      "enddate": _vm.currToDate
    },
    on: {
      "startchanged": _vm.onStartDateChanged,
      "endchanged": _vm.onEndDateChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "marg-20-right flex align-center pointer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeWeekends),
      expression: "includeWeekends"
    }],
    staticClass: "pointer",
    attrs: {
      "id": "weekendToggle",
      "type": "checkbox",
      "title": "Include weekends"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeWeekends) ? _vm._i(_vm.includeWeekends, null) > -1 : (_vm.includeWeekends)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeWeekends,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeWeekends = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeWeekends = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeWeekends = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "marg-05-left pointer",
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "for": "weekendToggle"
    }
  }, [_vm._v("Include weekends")])])]), _vm._v(" "), _c('div', {
    staticClass: "vacations-days-selector__year-calendar"
  }, [_c('h2', {
    staticClass: "marg-10-bottom"
  }, [(_vm.isKindergarten) ? [_vm._v("Institutionen har åbent " + _vm._s(_vm.schoolDaysCount) + " dage")] : [_vm._v(_vm._s(_vm.schoolDaysCount) + " " + _vm._s(_vm.$t('vue.vacations_days_selector.school_days')))]], 2), _vm._v(" "), _c('direct-day-selector', {
    attrs: {
      "from-date": _vm.currFromDate,
      "to-date": _vm.currToDate,
      "selected-days": _vm.initialSelectedDates,
      "include-weekends": _vm.includeWeekends
    },
    on: {
      "toggled": _vm.dayToggled
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2195af68!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VacationDaysSelector/VacationDaysSelector.vue
// module id = 1799
// module chunks = 1